/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled from '../compiled/components/live-region';
import Emotion from '../emotion/components/live-region';

// ==============================
// Root Container
// ==============================

var LiveRegion = function LiveRegion(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default LiveRegion;